module.exports = __webpack_public_path__ + "img/it.09d08b2.svg";